import { styled } from '@mui/system';

export const StyledWideImage = styled('img')(({ theme }) => ({
  objectFit: 'cover',
  width: '100%',
  height: '100%',
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(4, 0, 4, 0),
    objectPosition: 'center center',
  },
}));

export const StyledMockupImage = styled('img')(({ theme }) => ({
  objectFit: 'cover',
  width: '100%',
  height: '100%',
  maxWidth: '650px',
  maxHeight: '420px',
  objectPosition: 'top center',
  [theme.breakpoints.down('sm')]: {
    height: '25vh',
    width: 'auto',
  },
}));

export const StyledMockupImageContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  marginBottom: '2rem',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '1rem',
    height: '25vh',
    overflowX: 'hidden',
  },
}));
